<template>
  <div>
    <v-btn
      color="primary"
      text
      x-small
      :loading="loading"
      @click="openDialog()"
    >
      More Calc Details
      <!-- <v-icon small color="primary" class="mx-2" x-small
            >mdi-dots-horizontal</v-icon
          > -->
    </v-btn>
    <v-dialog v-model="dialog" max-width="800" scrollable>
      <!-- <template v-slot:activator="{ on, attrs }">
     
      </template> -->

      <v-card>
        <v-card-title class="orangeCardTitle d-flex flex-row"
          ><div>Calculation Details</div>
          <v-spacer></v-spacer>
          <v-btn icon color="primary" @click="dialog = false"
            ><v-icon>mdi-close</v-icon></v-btn
          ></v-card-title
        >
        <v-card-text class="pt-6">
          <div v-for="(row, i) in boxes" :key="i">
            <div class="d-flex flex-row flex-wrap justify-center">
              <div
                v-for="(box, j) in row"
                :key="`${i}_${j}`"
                style="position: relative; text-align: center"
              >
                <v-card class="aBox" color="#edf8ff" :style="boxStyle">
                  <!-- {{ box.title }} {{ box.key }} {{ j }} -->
                  <div class="overline">{{ box.title }}</div>
                  <optical-cross-image
                    v-if="objectsForKey[box.key]"
                    style="margin-top: -15px"
                    :obj="objectsForKey[box.key].obj"
                    :type="box.type"
                    :dimensions="
                      $vuetify.breakpoint.smAndUp ? mapSize : mobileMapSize
                    "
                    :showHeatmap="box.heatmap"
                    class="mx-auto"
                  ></optical-cross-image>
                  <div
                    v-if="
                      objectsForKey[box.key] && objectsForKey[box.key].caption
                    "
                    class="caption pb-2"
                  >
                    {{ objectsForKey[box.key].caption }}
                  </div>
                </v-card>

                <v-icon
                  x-large
                  color="blue"
                  v-if="j == 0"
                  :style="mathIconStyle"
                  class="mathIconClass"
                  >mdi-{{ i == 1 ? "plus" : "minus" }}</v-icon
                >
                <v-icon
                  x-large
                  color="blue"
                  v-if="j == 1"
                  :style="mathIconStyle"
                  class="mathIconClass"
                  >mdi-equal</v-icon
                >
              </div>
            </div>
            <v-divider class="my-2"></v-divider>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- {{ results }} -->
  </div>
</template>

<script>
// import Name from "../dir/file";
import OpticalCrossImage from "@/components/clStuff/OpticalCrossImage";
import RxMethods from "@/assets/js/cls/RxMethods";

export default {
  name: "ClCalcVerbose",
  components: {
    OpticalCrossImage,
  },
  mixins: [RxMethods],
  props: {
    results: null,
    refraction: null,
    keratometry: null,
  },
  data: function () {
    return {
      dialog: false,
      mapSize: 80,
      mobileMapSize: 120,
      loading: false,
      boxes: [
        [
          {
            title: "Lens Base Curve",
            key: "bc",
            type: "keratometry",
          },
          {
            title: "Keratometry",
            key: "keratometry",
            type: "keratometry",
            heatmap: true,
          },
          {
            title: "Tear Lens Power",
            key: "tearLens",
            type: "NaFl",
            heatmap: true,
          },
        ],
        [
          { title: "Lens Power", key: "lensPower" },
          {
            title: "Tear Lens Power",
            key: "tearLens",
            type: "NaFl",
            heatmap: true,
          },
          { title: "Total Power", key: "totalPower" },
        ],
        [
          { title: "Rx (Vertexed)", key: "vRx" },
          { title: "Total Power", key: "totalPower" },
          { title: "Uncorrected Rx", key: "residualRx" },
        ],
      ],
    };
  },
  methods: {
    openDialog() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 3000);
      setTimeout(() => {
        this.dialog = true;
      }, 500);
    },
  },
  computed: {
    vRxObj: function () {
      if (!this.refraction) return null;
      return this.diffVertex(this.refraction);
    },
    residualRxObj: function () {
      if (!this.results?.residualRx) return null;
      return this.parseRxString(this.results.residualRx);
    },
    tearLensObj: function () {
      if (!this.results?.tearLens) return null;
      return this.parseRxString(this.results.tearLens);
    },
    baseCurveObj: function () {
      if (!this.results?.fullBC) return null;
      return this.parseKstring(this.results.fullBC);
    },
    lensPowerObj: function () {
      if (!this.results?.fullPower) return null;
      return this.parseRxString(this.results.fullPower);
    },
    totalPowerObj: function () {
      if (!this.lensPowerObj || !this.tearLensObj) return null;
      return this.addRx(this.lensPowerObj, this.tearLensObj);
    },
    objectsForKey: function () {
      let rtn = {};
      //   let r = this.results;
      if (this.baseCurveObj)
        rtn.bc = { obj: this.baseCurveObj, caption: this.results?.baseCurve };
      if (this.keratometry)
        rtn.keratometry = {
          obj: this.keratometry,
          caption: this.prettyFullKstring(this.keratometry),
        };
      if (this.tearLensObj)
        rtn.tearLens = {
          obj: this.tearLensObj,
          caption: this.prettyStringMinus(this.tearLensObj),
        };
      if (this.lensPowerObj)
        rtn.lensPower = {
          obj: this.lensPowerObj,
          caption: this.prettyStringMinus(this.lensPowerObj),
        };
      if (this.totalPowerObj)
        rtn.totalPower = {
          obj: this.totalPowerObj,
          caption: this.prettyStringMinus(this.totalPowerObj),
        };
      if (this.vRxObj)
        rtn.vRx = {
          obj: this.vRxObj,
          caption: this.prettyStringMinus(this.vRxObj),
        };
      if (this.residualRxObj)
        rtn.residualRx = {
          obj: this.residualRxObj,
          caption: this.prettyStringMinus(this.residualRxObj),
        };
      return rtn;
    },
    mathIconStyle: function () {
      let rtn = "left: 50%; bottom:-30px; ";
      if (this.$vuetify.breakpoint.smAndUp) {
        rtn = "right: -40px; top: 50%; ";
      }
      return rtn;
    },
    boxStyle: function () {
      let rtn = "min-width:300px; margin: 5px 5px 25px;";
      if (this.$vuetify.breakpoint.smAndUp) {
        rtn = "width:200px; margin: 5px 15px 5px 15px;";
      }
      return rtn;
    },
  },
  //   watch: {
  //     dialog(val) {
  //       console.log("opening dialog", val);
  //       if (val) {
  //         this.tempLoading();
  //       }
  //     },
  //   },
};
</script>

<style scoped>
.aBox {
  min-height: 200px;
  text-align: center;
}
.mathIconClass {
  position: absolute;
  z-index: 2;
  transform: translate(-50%, -50%);
}
</style>
